import script from "./MyPortfolioProjectsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPortfolioProjectsPage.vue?vue&type=script&setup=true&lang=ts"

import "./MyPortfolioProjectsPage.vue?vue&type=style&index=0&id=6d904b18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d904b18"]])

export default __exports__